import React from 'react'
import CopilotAdoption from './CopilotAdoption'
import CopilotApproach from './CopilotApproach'
import Herosection from './Herosection'
import CopilotDelivery from './CopilotDelivery'
import WhySynectiks from './WhySynectiks'
import CopilotCTA from './CopilotCTA'

const Index = () => {
  return (
    <div>
      <Herosection />
      <CopilotAdoption />
      <CopilotApproach />
      <CopilotDelivery />
      <WhySynectiks />
      <CopilotCTA />
    </div>
  )
}

export default Index